import { Environment } from '@react-three/drei'
import { useMemo } from 'react'

import { useResourceUrl } from '@salsita-ai/platform-project-sdk/react'

import { usePreloadGltf } from './scene/use-preload-gltf'

export const AppEnvironment = () => {
  const { getResourceUrl } = useResourceUrl()

  const environmentUrl = useMemo(() => {
    return getResourceUrl('environments/interior_haussmannian_front_day_light_07.hdr')
  }, [getResourceUrl])

  // the active shorts are already loaded based on the remote objects defined in the domain,
  // the other shorts will be loaded after a delay to avoid prolonging the initial loading throbber
  usePreloadGltf(['models/swim-shorts.glb', 'models/board-shorts.glb'], 2000)

  return (
    <>
      <directionalLight position={[-1000, 2000, 3000]} intensity={0.5} color="#ff899b" /> {/* front (left) top light */}
      <directionalLight position={[1000, 2000, -3000]} intensity={0.5} color="#97aaff" /> {/* back (right) top light */}
      <directionalLight position={[2000, 2000, 0]} intensity={0.3} color="#ffffff" /> {/* back right light */}
      <directionalLight position={[-2000, 15000, 1000]} intensity={0.7} /> {/* top (left, front) light */}
      {/* <ambientLight intensity={0.3} /> */}
      <Environment files={environmentUrl} />
    </>
  )
}
